import React from 'react'
import PropTypes from 'prop-types'

// Components
import Header from '../components/Header'
import Footer from '../components/Footer'

const politicaPage = ({history}, context) =>
  <div>
    <Header name="site-header" style={{paddingBottom: '150px', marginBottom: '-130px'}}>
      <div className="container">
        <div className="grid-center">
           <div className="col-8_md-10 grid-column content center">
             <h1>
              {context.t('POLÍTICA DE DEVOLUÇÃO', {}, 'Texto politica de devolucao')}
             </h1>
           </div>
        </div>
      </div>
    </Header>
    <section className="politica-section" style={{marginBottom: '100px'}}>
      <div className="container politica" style={{ backgroundColor: '#fff', borderRadius: '0.5rem' }}>

        <div className="content-list">
          <div>
              <p>{context.t('As Assinaturas pagas podem ser compradas diretamente no Talkative, por meio de (1) pagamento de assinatura mensal ou anual (“Assinatura paga”); ou (2) pré-pagamento, fornecendo a você acesso ao Serviço Talkative por um período específico ("Período Pré-pago"), que se encerrará automaticamente, salvo se for convertida em assinatura mensal. ', {}, 'Texto politica de devolucao')}</p>
              
              <p>{context.t('Se você se cadastrar para uma Assinatura Paga, poderá mudar de ideia por qualquer ou nenhum motivo e receber um reembolso integral de todos os valores pagos em até quatorze (14 dias) a partir do dia de inscrição no serviço pertinente (o "Período de Análise"), na forma do art. 49 do Código de Defesa do Consumidor. Porém, a devolução de valores não será realizada se o aplicativo for acessado durante o “Período de Análise”.', {}, 'Texto politica de devolucao')}</p>
              
              <p>{context.t('A menos que sua assinatura tenha sido comprada como um Período Pré-pago, seu pagamento para o Talkative será automaticamente renovado ao final do período de assinatura, a menos que você cancele sua Assinatura Paga por meio da página de assinatura antes do final do período da assinatura atual. O cancelamento entrará em vigor no dia seguinte ao último dia do período de assinatura atual e você não terá mais acesso ao aplicativo. No entanto, se você cancelar seu pagamento ou a Assinatura Paga (1) depois que tiver acessado o Talkative durante o Período de Análise, ou (2) depois que o Período de Análise tiver terminado (onde aplicável), ou (3) antes do final do período de assinatura atual, não reembolsaremos nenhuma tarifa de assinatura que já tiver sido paga para nós. O método de reembolso dependerá do método de pagamento.', {}, 'Texto politica de devolucao')}</p>
              
              <p>{context.t('Se quiser receber um reembolso integral de todo o valor pago antes do término do Período de Análise, você deverá entrar em contato com o Suporte ao Cliente.', {}, 'Texto politica de devolucao')}</p>
              
              <p>{context.t('O Talkative poderá, de tempos em tempos, alterar o preço das Assinaturas Pagas, do Período Pré-pago (para períodos que ainda não foram pagos), e informará quaisquer alterações de preço a você com antecedência e, se aplicável, como aceitar estas alterações. As alterações de preços das Assinaturas Pagas entrarão em vigor no início do próximo período de assinatura, depois da data da mudança de preço. Conforme permitido pela lei local, você aceitará o novo preço ao continuar usando o Serviço Talkative depois que a alteração de preço entrar em vigor. Se você não concordar com as mudanças de preços, terá o direito de rejeitar a alteração ao cancelar a assinatura do Serviço Talkative antes que a alteração de preço entre em vigor. Portanto, certifique-se de ler atentamente qualquer aviso do tipo sobre alterações de preço.', {}, 'Texto politica de devolucao')}</p>
          </div>
        </div>
      </div>
    </section>
    <Footer />

  </div>
politicaPage.contextTypes = {
  t: PropTypes.func.isRequired
}

export default politicaPage



// WEBPACK FOOTER //
// ./src/pages/devolucao.js